import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Text } from '@chakra-ui/react';
import { ChevronLeftIcon } from '@chakra-ui/icons';

import messages from './messages';

export const BackButton = ({ to }) => (
  <Link as={RouterLink} to={to}>
    <Box display="flex" alignItems="center" mb={4}>
      <ChevronLeftIcon mr={1} boxSize={6} />
      <Text>
        <FormattedMessage {...messages.buttonLabel} />
      </Text>
    </Box>
  </Link>
);
